import { Component, error, Node, _decorator } from 'cc';
import Lobby from '../../../System/Lobby';
import OuterLobbyUIController from '../../Controller/UIController/OuterLobbyUIController';
import WebViewManager from '../../WebViewManager';

const { ccclass, property } = _decorator;

@ccclass('SharedAsset')
export default class SharedAsset extends Component {
    @property(Node)
    public readonly lobbyView: Node = null;
    @property(WebViewManager)
    public readonly webViewManager: WebViewManager = null;

    private _outerLobbyUIController: OuterLobbyUIController = null;

    public get outerLobbyUIController(): OuterLobbyUIController {
        if (!this._outerLobbyUIController) {
            this.lobbyView.getComponentInChildren(OuterLobbyUIController);
        }
        return this._outerLobbyUIController;
    }

    public onLoad() {
        if (Lobby.sharedAsset) {
            this.destroy();
            error('No duplicate GameSharedAsset');
            return;
        }
        Lobby.sharedAsset = this;
    }
}
